import { RecInv } from "./Invoiceable";

export const EXPIRATION_TRANSLATOR = {
  0: 'A la vista',
  30: '30 días',
  60: '60 días',
  90: '90 días',
};

export class RecurringInvoiceContract {
  id: number
  duration: number = null;
  start_date: string = '';
  end_date: string = '';
  expiration: number = 0;
  create_auto: boolean = false;
  send_auto: boolean = false;
  interval: string = 'mensual';
  period: string = 'adelantado';
  state: string = 'not_started'
  invoice: RecInv;

  constructor(
    id: number,
    duration: number = null,
    start_date: string = '',
    end_date: string = '',
    expiration: number = 0,
    create_auto: boolean = false,
    send_auto: boolean = false,
    interval: string = 'mensual',
    period: string = 'adelantado',
    state: string = 'not_started',
    invoice?: RecInv
  ) {
    this.id = id;
    this.duration = duration;
    this.start_date = start_date;
    this.end_date = end_date;
    this.expiration = expiration;
    this.create_auto = create_auto;
    this.send_auto = send_auto;
    this.interval = interval;
    this.period = period;
    this.state = state;
    this.invoice = invoice;
  }

    clone(): RecurringInvoiceContract {
      let invoice = this.invoice.clone() as RecInv;
      return new RecurringInvoiceContract(
        this.id,
        this.duration,
        this.start_date,
        this.end_date,
        this.expiration,
        this.create_auto,
        this.send_auto,
        this.interval,
        this.period,
        this.state,
        invoice
      );
    }
    compute() {
      this.invoice.compute();
    }
    
}

